"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useErrorDetection = useErrorDetection;
var _react = _interopRequireWildcard(require("react"));
var _useScriptInjector = require("@site/pattern-library-utils/hooks/useScriptInjector");
var _leadGenScript = require("@site/pattern-library-utils/lead-gen-script");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Script statuses that indicate loading failures
const SCRIPT_FAILURE_STATES = [_useScriptInjector.SCRIPT_STATUS.ERROR, _useScriptInjector.SCRIPT_STATUS.IDLE];

// Checks if a window message event contains a lead gen load error
function isLeadGenLoadErrorEvent(event) {
  const isSameOrigin = event.origin === window.origin;
  // Listen for the NotificationEvent error type
  const isLoaderError = event.data?.event === 'lead-gen.loader.error';
  return isSameOrigin && isLoaderError;
}

// Hook that listens for lead gen error events from window messages
function useLeadGenErrorEventListener(setHasError) {
  (0, _react.useEffect)(() => {
    function handleMessage(e) {
      if (isLeadGenLoadErrorEvent(e)) setHasError(true);
    }
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [setHasError]);
}

// Hook that detects script loading failures based on script status
function useScriptStatusErrorDetection(scriptStatus, setHasError) {
  const hasScriptLoadFailed = (0, _react.useMemo)(() => SCRIPT_FAILURE_STATES.includes(scriptStatus) || scriptStatus === _useScriptInjector.SCRIPT_STATUS.READY && !(0, _leadGenScript.isLeadGenAvailable)(), [scriptStatus]);
  (0, _react.useEffect)(() => {
    if (hasScriptLoadFailed) {
      setHasError(true);
    }
  }, [hasScriptLoadFailed, setHasError]);
}

// Main hook that detects lead gen form loading failures from multiple sources
function useErrorDetection(scriptStatus) {
  const [hasError, setHasError] = _react.default.useState(false);
  useScriptStatusErrorDetection(scriptStatus, setHasError);
  useLeadGenErrorEventListener(setHasError);
  return hasError;
}